define('OutOfStockMessage.Custom', [
], function OutOfStockMessageCustom(
) {
    'use strict';

    return {
        mountToApp: function mountToApp(container) {
            var layout = container.getComponent('Layout');
            layout.addToViewContextDefinition('ProductLine.Stock.View', 'showOutOfStockMessage', 'boolean', function addToViewContextDefinition(context) {
                var item = context.model.item ? context.model.item : context.model;
                var itemQuantity = item.quantityavailable + (item.custitem_dhi_qty_avail_build_stored || 0);
                var showOutOfStockMessage = !(itemQuantity > 0 || !context.stockInfo.showOutOfStockMessage);
                return showOutOfStockMessage;
            });
        }
    };
});
